import type { SVGProps } from 'react';
const SvgOutlinedEdit = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} fill="none" {...props}>
    <path
      fill="#ED131C"
      fillRule="evenodd"
      d="M11.63 3.162 5.167 9.664a1.26 1.26 0 0 1-.713.359l-2.263.325a.42.42 0 0 1-.458-.285.4.4 0 0 1-.018-.193l.323-2.277c.039-.272.164-.525.358-.72L8.857.373a1.26 1.26 0 0 1 1.786 0l.988.994a1.275 1.275 0 0 1 0 1.796zm-3.77-.588L2.988 7.476a.44.44 0 0 0-.119.24l-.243 1.72 1.708-.246a.42.42 0 0 0 .238-.12l4.871-4.903L7.858 2.58zm2.174.995.999-1.006a.42.42 0 0 0 0-.598L10.045.97a.42.42 0 0 0-.595 0l-.999 1.005zm-9.589 8.43a.42.42 0 0 1-.41-.255.426.426 0 0 1 .242-.566.4.4 0 0 1 .168-.025h7.15a.42.42 0 0 1 .445.423.43.43 0 0 1-.276.398.4.4 0 0 1-.169.025z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgOutlinedEdit;
